import { appConfig } from "@/config";
import { $paths } from "@/constants";

// Application layouts
const { layouts } = appConfig;

/** Routes meta  */
const meta = { layout: layouts.app, requiresAuth: true };

/**
 * User routes
 */
const userRoutes = [
  {
    path: $paths.users,
    name: "users",
    meta,
    component: () => import("@/views/Users/ManageUsers.vue"),
  },
  {
    path: $paths.user,
    name: "user",
    meta,
    component: () =>
      import(/* webpackChunkName: "user" */ "@/views/Users/User/User.vue"),
  },
];

export default userRoutes;
